module.exports = new __parcel__URL__("snake and ladders.9ff9b433.png").toString();